import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';

import RangeSlider from './rangeslider';
import SearchButton from './button';
import Checkboxes from './checkbox';

class Filters extends Component {

    componentDidUpdate(){
        //console.log(this.props.filters);
    }

    handleSubmit = () => {
        this.props.actions.setFilteredEstate({estates: this.props.estates, filters: this.props.filters});
    }

    handleEnter = ({key}) => {
        if (key==='Enter') {
            this.props.actions.setFilteredEstate({estates: this.props.estates, filters: this.props.filters})
        };
    }

    render(){
        const filters = this.props.filters;
        const actions = this.props.actions;

        return (
            <div className="col-lg-4 col-md-4 col-xs-12 col-md-pull-8">
                <div className="sidebar-widget">
                    <div className="main-title-2">
                        <h1><span>Nouvelle</span> Recherche</h1>
                    </div>

                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Checkboxes
                                name={'Type de propriété'}
                                values={filters.sellType}
                                onChange={actions.setSellType}/>
                        </Grid>

                        <Grid item xs={12}>
                            <Checkboxes
                                name={'Types de bien'}
                                values={filters.bienType}
                                onChange={actions.setBienType}/>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                id="outlined-full-width"
                                label="Référence"
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem',
                                    width: '90%'
                                }}
                                placeholder="Référence"
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                onChange={(e) => actions.setReference(e.target.value)}
                                value={filters.reference}
                                onKeyPress={this.handleEnter}
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        fontSize: 14
                                    },
                                }}
                                InputProps={{
                                    style: {
                                        fontSize: 14
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="outlined-full-width"
                                label="Ville"
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem',
                                    width: '90%'
                                }}
                                placeholder="Ville"
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                onChange={(e) => actions.setCity(e.target.value)}
                                value={filters.city}
                                onKeyPress={this.handleEnter}
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        fontSize: 12
                                    },
                                }}
                                InputProps={{
                                    style: {
                                        fontSize: 12
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <RangeSlider
                                name='Surface'
                                range={filters.surfaceRange}
                                value={filters.surfaceValues}
                                onChange={actions.setSurfaceValues}
                                valueFormat={(a) => `${a}m2`}/>
                        </Grid>
                        <Grid item xs={12}>
                            <RangeSlider
                                name='Prix'
                                range={filters.prixRange}
                                value={filters.prixValues}
                                onChange={actions.setPrixValues}
                                valueFormat={(a) => `${a}€`}/>
                        </Grid>
                        <Grid item xs={12}>
                            <RangeSlider
                                name='Nombre de chambre'
                                range={filters.chambresRange}
                                value={filters.chambresValues}
                                onChange={actions.setChambresValues}
                                valueFormat={a => a}/>
                        </Grid>
                    </Grid>
                    <br/>
                    <Divider variant="middle" />
                    <br/>
                    <SearchButton  onClick={this.handleSubmit} content='Rechercher'/>
                </div>
            </div>
        )
    }
}

export default Filters;
